import {isDaumBlogDomain} from "../../../utils/UriUtil";

export const graphConfig = {
  listeners: [],
  type: "serial",
  theme: "light",
  addClassNames: true,
  marginTop: 15,
  marginBottom: 0,
  marginLeft: 29,
  marginRight: 30,
  autoMargins: false,
  bezierX: 100,
  mouseWheelZoomEnabled: false,
  startDuration: 0.1,
  startEffect: "easeInSine",
  balloon: {
    drop: true,
    adjustBorderColor: true,
    borderAlpha: 0,
    color: "#000000",
    cornerRadius: 0,
    pointerWidth: 0,
    fillColor: "#FFFFFF",
    fillAlpha: 0.5
  },
  graphs: [
    {
      id: "searchChart",
      showBalloon: false,
      fillAlphas: 0.5,
      lineAlpha: 1,
      lineColor: "#ffffff",
      lineThickness: 1,
      title: "searchEngine",
      type: "column",
      valueField: "searchEngine",
      fillColors: isDaumBlogDomain() ? "#1a9be4" : "#FE5544",
      labelText: "searchEngine",
      cornerRadiusTop: 1.5,
      fixedColumnWidth: 5,
    },
    {
      id: "snsChart",
      showBalloon: false,
      fillAlphas: 0.5,
      lineAlpha: 1,
      lineColor: "#ffffff",
      lineThickness: 1,
      title: "sns",
      type: "column",
      valueField: "sns",
      fillColors: "#00C3A9",
      cornerRadiusTop: 1.5,
      fixedColumnWidth: 5,
    },
    {
      id: "etcChart",
      showBalloon: false,
      fillAlphas: 0.5,
      lineAlpha: 1,
      lineColor: "#ffffff",
      lineThickness: 1,
      title: "etc",
      type: "column",
      valueField: "etc",
      fillColors: "#9BA5AF",
      cornerRadiusTop: 1.5,
      fixedColumnWidth: 5,

    },
    {
      id: "fakeChart",
      showBalloon: true,
      title: "fake",
      type: "column",
      fillAlphas: 0,
      lineAlpha: 0,
      valueField: "fake",
      borderThickness: 0,
      balloonFunction: null,
      fixedColumnWidth: 5,
    },
  ],
  chartCursor: {
    oneBalloonOnly: true,
    cursorAlpha: 0,
    categoryBalloonEnabled: false,
    leaveCursor: true,
    zoomable: false,

  },
  categoryField: "timestamp",
  categoryAxis: {
    parseDataProviders: false,
    gridAlpha: 0,
  },
  valueAxes: [{
    dashLength: 3,
    axisAlpha: 0.1,
    minimum: 0,
    maximum: 0,
    stackType: "regular",
    labelsEnabled: false,
    autoGridCount: false

  }],
  dataProvider: []
};
